import {TouchableOpacity, View} from "react-native";
import TextM from "@common/components/text/TextM";
import TextInputM from "@common/components/input/TextInputM";
import React, {useContext, useState} from 'react'
import {theme} from "@common/theme/theme";
import {ModalM} from "@common/components/modal/ModalM";
import SchoolSubjectModal from "../../../organize/school-subjects/SchoolSubjectModal";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {IconImageM} from "@common/components/icons/IconsM";

export const HomeworkAssistance = ({
                                       control,
                                       schoolSubjects,
                                       handleSelectSubject,
                                       selectedSubject,
                                       questions
                                   }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const dimensions = useContext(DimensionsContext)

    return <View style={{
        marginTop: 20,
        width: dimensions?.width - 40,
        alignSelf: "center"
    }}>
        <TextM color={theme.colors.primary}
               fontWeight={"Medium"}
               wrap
               fontSize={12}>
            {questions[0]}
        </TextM>
        <TextInputM
            placeholder="Décrivez le devoir ou la tâche"
            name='chapter'
            control={control}
            multiline={true}
            style={{
                marginBottom: 20,
                alignSelf: 'center',
                width: dimensions?.width - 40,
                height: 94
            }}
        />

        <TextM color={theme.colors.primary}
               fontWeight={"Medium"}
               wrap
               fontSize={12}>
            {questions[1]}
        </TextM>
        <TouchableOpacity
            onPress={() => {
                setModalVisible(true);
            }}
            style={{
                height: 50,
                flexDirection: "row",
                alignSelf: 'center',
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: theme.roundness,
                paddingVertical: 10,
                paddingHorizontal: 15,
                marginTop: 2,
                borderWidth: 1,
                borderColor: theme.colors.lightMore,
                backgroundColor: theme.colors.white,
                width: dimensions?.width - 40,
            }}
        >
            <View style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 3,
            }}>
                {selectedSubject?.icon && <IconImageM uri={selectedSubject?.icon} width={18} style={{}}/>}
                <TextM color={theme.colors.primary}>
                    {selectedSubject?.label || 'Choisir une matière'}
                </TextM>
            </View>
        </TouchableOpacity>
        <ModalM visible={modalVisible} onDismiss={() => setModalVisible(false)} style={{height: "90%"}}>
            <SchoolSubjectModal onSelectSchoolSubject={(value) => {
                setModalVisible(false);
                handleSelectSubject(value)
            }}
                                options={schoolSubjects}
                                setVisible={setModalVisible}
            />
        </ModalM>
    </View>
};